<ng-container *transloco="let t">
  <div id="chat-card-container" class="fixed right-4 bottom-4 z-[59]">
    <button
      id="chat-card-button"
      type="button"
      class="flex items-center gap-1.5 md:gap-4 py-2 px-4 md:py-4 md:px-8 rounded-[20px] border-none cursor-pointer transition-all duration-200 bg-ld-primary hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(80,18,131,0.4)] active:translate-y-0 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2 touch-action-manipulation"
      (click)="onCardClick()"
      [attr.aria-label]="t('chatCardAriaLabel')"
      [disabled]="isLoading()"
    >
      @if (isLoading()) {
        <div id="chat-card-spinner" class="flex items-center justify-center shrink-0 w-6 h-6 md:w-10 md:h-10">
          <div class="w-4 h-4 md:w-7 md:h-7 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
        </div>
        <span class="font-dm font-semibold text-sm md:text-xl leading-5 md:leading-7 text-white whitespace-nowrap">
          {{ t('commonLabelsLoading') }}
        </span>
      } @else {
        <div class="flex items-center justify-center shrink-0">
          <ld-svg-icon [src]="chatIcon" class="w-6 h-6 md:w-10 md:h-10" aria-hidden="true" />
        </div>
        <span class="font-dm font-semibold text-sm md:text-xl leading-5 md:leading-7 text-white whitespace-nowrap">
          {{ t(heading()) }}
        </span>
      }
    </button>
  </div>
</ng-container>
